var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedirectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 12C0.966671 12 0.652671 11.8693 0.391331 11.608C0.130001 11.3467 -0.000438891 11.0329 1.10941e-06 10.6667V1.33333C1.10941e-06 0.966671 0.130671 0.652671 0.392001 0.391331C0.653331 0.130001 0.967111 -0.000438891 1.33333 1.10941e-06H6V1.33333H1.33333V10.6667H10.6667V6H12V10.6667C12 11.0333 11.8693 11.3473 11.608 11.6087C11.3467 11.87 11.0329 12.0004 10.6667 12H1.33333ZM4.46667 8.4667L3.53333 7.53333L9.7333 1.33333H7.33333V1.10941e-06H12V4.66667H10.6667V2.26667L4.46667 8.4667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectIcon);
export default __webpack_public_path__ + "static/media/redirect_icon.bac1422409464d3a7aa20e10658c0218.svg";
export { ForwardRef as ReactComponent };